import $ from 'jquery';
import {
  alertMessagePopup,
  attendeeAttachPhotosByQR,
  customPopUp,
  getParameterByName,
  getQueryVariable,
  hideLoading,
  remoteCapture,
  showLoading,
  trackListOfPhotoEvent,
  trackPhotoEvent,
  isMobile,
  pAttendeeAttachPhotosByQR,
  deleteImagesReq,
  isIPhone,
  initMultipleDownload,
  showBlockingError,
} from './utils-module.js';
import * as fullScreenView from './fullScreenView.js';
import { customImageUpload, isUnsupportedPictureFormatError, uploadSelfieImage } from './uploadPhotosUtil.js';
import { generateUrlForEmail } from './registration/index.js';
import { initMenu, updateQRMenuText } from './menu.js';
import {
  findAttendeeByUIDAndEventId,
  findPhotos,
  print,
  captureEvents,
  addVisitDateInfo,
  findEvent,
} from '../../../packages/src/api/index.js';
import { occoApi } from './occoAPI-module.js';
import { initWaitingNotice } from './waitingNotice.js';
import { initModeSwitcher } from './modeSwitcher.js';
import { initSelect } from './select.js';
import { initGalleryViewController } from './imageList.js';
import { initActionPanel } from './actionPanel.js';
import { initSelectedPanel } from './panel-selected.js';
import { init as initZendesk } from './zendesk.js';
import * as photoDC from './photoDS.js';
import { pageParams } from './page.js';
import * as createAStoryBtn from './createAStoryBtn.js';
import * as createAStory from './createAStory.js';
import { setLogo } from './customizePage/home.js';
import multiAccounts from './multiAccounts/index.ts';
import * as multiAccountsView from './multiAccounts/view.ts';
import { initEventOrganisationDataStorage } from '../../../packages/src/eventOrganisationDataStorage.js';
import { checkIncognitoMode } from './incognito-detector.js';

import 'bootstrap';
import '../libs/js/jquery-qrcode-0.15.0.min.js';
import '../libs/js/qrcode-reader.min.js';
import {
  getWatermarkSrc,
  initAccessDataStorage,
  initWatermarkStorage,
  isAvailableToUsePhoto,
  isEnabledWatermarkBySrc,
  makeAccessData,
} from './accessData.js';
import * as UGC from './Tooltips/ugc.js';
import * as faceReco from './Tooltips/faceReco.js';
import { prepareSharePage, shareUrl } from './sharedAccount.js';
import { transformS3UrlToShareDomain } from '../../../packages/src/utils/domain.js';
import { latestStateRequestManager } from '../../../packages/src/utils/commonUtil.js';
import * as shareBucketApi from '../../../packages/src/api/shareInBucket.js';
import { redirectToPage } from './page-routes.js';
import * as homePageDispatcher from './homePageDispatcher.ts';
import { selectCurrentAccount, syncMultiAccounts } from './multiAccounts/mainController.ts';
import { isSessionExpired } from './utils/session.js';
import { calculateExpiredDate } from './multiAccounts/data.ts';
import { initEventLoc, setTextToElement, t } from './localization.js';
import { hasFaqContentHtml, hasPrivacyContentHtml } from '../localization/htmlContent.js';
import { initStoriboxFooter } from './storiboxFooter.js';

const MAX_NUMBER_OF_PHOTOS = 3000;

const { saveEventName, saveHomeLink, saveAttendeeUid } = pageParams;

const waitingNotice = initWaitingNotice();
const modeSwitcher = initModeSwitcher();
const selectImage = initSelect();
const galleryVC = initGalleryViewController();
const actionPanel = initActionPanel();
const selectedPanel = initSelectedPanel();
const multipleDownload = initMultipleDownload(waitingNotice);

let actionPanelButtons = [];

const watermarkStorage = initWatermarkStorage();
const accessDataStorage = initAccessDataStorage();
const eventOrganisationDataStorage = initEventOrganisationDataStorage();
accessDataStorage.setData(makeAccessData());

// Helper functions moved to outer scope
async function fetchAccountData(parsedQueryParams) {
  showLoading();
  let eventData;
  try {
    const response = await findEvent({ eventName: parsedQueryParams.eventCode, basicDataOnly: true });
    eventData = response.result;

    if (!eventData) {
      const errorMessage = parsedQueryParams.eventCode
        ? `This "${parsedQueryParams.eventCode}" event name (eName) doesn't exist. Please use right event name`
        : "The event code is missing. Please make sure you're using the correct link or QR code. If you continue to see this message, please contact support for assistance.";
      showBlockingError(errorMessage);
      return;
    }
  } catch (e) {
    console.error(e);
    showBlockingError(
      'An error occurred while loading the event. Please try again later or contact support if the problem persists.'
    );
    return;
  }

  const res = await findAttendeeByUIDAndEventId(parsedQueryParams.attendeeUid, eventData.id);

  return {
    attendeeUid: parsedQueryParams.attendeeUid,
    eventCode: parsedQueryParams.eventCode,
    eventLogo: eventData.opts.webappCustomLogoSrc,
    name: res.result.full_name,
    email: res.result.email_address || res.result.email,
    phoneNumber: res.result.phone_number,
    regDate: new Date(res.result.created_date),
    expiredDate: calculateExpiredDate(eventData, res.result),
  };
}

function isValidToken(tokenA, tokenB) {
  if (!tokenA || !tokenB) return false;
  return tokenA === tokenB;
}

function getStepOfReg() {
  return localStorage.getItem('step') || '2';
}

function goToFirstStep() {
  localStorage.setItem('step', '1');
}

function isEmptyParsedOpts(parsedOpts) {
  return Object.keys(parsedOpts || {}).length === 0;
}

function filterKeys(keys) {
  return (_, key) => !keys.includes(key);
}

function filterQuery(predicate) {
  const queryArray = [];
  new URLSearchParams(globalThis.location.search).forEach((value, key) => {
    if (predicate(value, key)) {
      queryArray.push([value, key]);
    }
  });
  return queryArray.reduce((acc, [value, key]) => {
    const and = acc === '' ? '?' : '&';
    return `${acc}${and}${key}=${value}`;
  }, '');
}

function updatePageQueryString(queryString) {
  if (queryString === '') {
    globalThis.location.href = globalThis.location.origin + globalThis.location.pathname;
  } else {
    globalThis.location.search = queryString;
  }
}

async function isNeedToShowPrivacy() {
  return hasPrivacyContentHtml();
}

async function isNeedToShowFaq() {
  return hasFaqContentHtml();
}

function isPhotoFavorite(photo) {
  return Boolean(photo?.is_favorite);
}

function redirectToExternalPurchasePage(webappPurchaseRedirectUrl, account) {
  webappPurchaseRedirectUrl = webappPurchaseRedirectUrl?.replace('{attendee_uid}', account?.attendeeUid);
  globalThis.location.href = webappPurchaseRedirectUrl;
}

function OCCOAppPages() {
  let IMAGE_DATA = [];
  const self = this;
  let ATT_ID = null;
  let EVENT_NAME = null;
  let EVENT_DATA = null;
  let EVENT_OPTS = null;
  let SHIPPING_ADDRESS = null;
  let HAS_FULL_IMAGE_ACCESS = 1;
  let ATTENDEE_STATE = {};
  let VISIT_DATE = null;
  let FACE_RECO = true;
  let isDisableSelfies = false;
  let isEnableFaceRec = false;
  let AUTO_RC = null;

  this.init = async function () {
    multiAccountsView.render(multiAccounts.getList(), multiAccounts.getCurrentIndex());
    const parsedQueryParams = {
      attendeeUid: getQueryVariable('uId'),
      eventCode: getQueryVariable('eName'),
      fr: getQueryVariable('fr'),
      imgSrc: getQueryVariable('imgSrc'),
      photoId: getQueryVariable('photoId'),
      token: getQueryVariable('token'),
      uploadUGC: getQueryVariable('uploadUGC'),
      tg: getQueryVariable('tg'),
      showQR: getQueryVariable('showQR'),
      aiKiosk: getQueryVariable('aiKiosk'),
      ignoreIncognito: getQueryVariable('iic'),
      afterIncognito: getQueryVariable('aim'),
    };

    await selectCurrentAccount({
      parsedQueryParams,
      multiAccounts,
      fetchAccountData,
    });

    await syncMultiAccounts({ multiAccounts });

    const currentAccount = multiAccounts.getCurrentAccount();
    if (currentAccount) {
      ATT_ID = currentAccount.attendeeUid;
      EVENT_NAME = currentAccount.eventCode;
    } else {
      ATT_ID = parsedQueryParams.attendeeUid;
      EVENT_NAME = parsedQueryParams.eventCode;
    }

    if (multiAccounts.getList().length === 0 && !EVENT_NAME) {
      showBlockingError(t('home-no-albums-found-message'));
      return;
    }
    AUTO_RC = getQueryVariable('rc') === 'true';
    FACE_RECO = getQueryVariable('fr') !== 'false';

    if (AUTO_RC === true) {
      if (localStorage.getItem('locWA')) {
        localStorage.setItem('home', generateUrlForEmail());
      }
    } else {
      localStorage.setItem('home', globalThis.location.href);
    }

    showLoading();
    let result;
    try {
      const response = await findEvent({ eventName: EVENT_NAME, basicDataOnly: true });
      result = response.result;
    } catch {
      showBlockingError(t('home-event-load-error-message'));
      return;
    }
    if (!result) {
      showBlockingError(`This "${EVENT_NAME}" event name (eName) doesn't exist. Please use right event name`);
      return;
    }
    await initEventLoc(result);
    initMenu();

    if (result.organisation) {
      eventOrganisationDataStorage.storeEventOrganisationData(result.organisation);
    }

    initStoriboxFooter();

    hideLoading();

    actionPanelButtons = [
      // { id: 'share', iconName: 'share', text: isIPhone() ? 'Share/Download' : 'Share' },
      { id: 'shareLink', iconName: 'share', text: t('share-btn') },
      { id: 'multipleDownload', iconName: 'download', text: t('download-btn') },
      { id: 'purchase', iconName: 'payment', text: t('purchase-btn') },
      { id: 'delete', iconName: 'delete', text: t('delete-btn') },
    ];
    setTextToElement('.float-button .purchase-btn', t('purchase-btn'));

    const { opts } = result;

    // NOTE: needs for debugging options
    console.log('opts', opts);

    EVENT_DATA = result;
    localStorage.setItem('eventPublicApiKey', EVENT_DATA.public_api_key);
    if (opts) {
      EVENT_OPTS = result.opts;
    }

    logPhotoDelayValues();

    if (result.shopify_shipping_address) {
      SHIPPING_ADDRESS = result.shopify_shipping_address;
    }

    watermarkStorage.setSrc(EVENT_DATA.protector_watermark);

    // NOTE: for test initZendesk('dbfef4a1-5495-4537-a555-df6c1689140e');
    initZendesk(opts.zendeskKey);

    const [isShowPrivacyLink, isShowFaqLink] = await Promise.all([isNeedToShowPrivacy(), isNeedToShowFaq()]);

    VISIT_DATE = 1;
    $('#eventLogoCont').css('display', 'flex');
    if (AUTO_RC === true) {
      const codeMRC1 = getQueryVariable('mrc1');
      remoteCapture(ATT_ID, codeMRC1);
    }

    saveHomeLink(globalThis.location.href);
    $('#selfie').hide();

    if (isEmptyParsedOpts(opts)) {
      showBlockingError(t('home-event-config-missing-message'));
      return;
    }

    isDisableSelfies = !FACE_RECO || opts.isDisableSelfies;
    isEnableFaceRec = !FACE_RECO || EVENT_DATA.enable_facial_recognition === 1;

    if (isDisableSelfies || !isEnableFaceRec) {
      UGC.show();
      faceReco.off();
      $('#selfies').hide();
    } else if (isEnableFaceRec) {
      faceReco.reset();
    }

    const mode = homePageDispatcher.getMode({
      parsedQueryParams,
      eventOpts: opts,
      stepReg: getStepOfReg(),
      account: multiAccounts.getCurrentAccount(),
    });

    if (mode.startsWith('registrationByIdFirst')) {
      goToFirstStep();
      saveEventName(EVENT_NAME);

      const isIncognito = await checkIncognitoMode();

      if (isIncognito && parsedQueryParams.ignoreIncognito !== 'true') {
        redirectToPage.incognitoMode({ rawSearch: globalThis.location.search });
      } else {
        // Capture event if user successfully exited incognito mode
        if (parsedQueryParams.afterIncognito === 'true') {
          captureEvents({
            EventSource: 'WebApp',
            EventName: 'SuccessfullyExitedIncognitoModePage',
            EventType: 'info',
            EventHref: globalThis.location.href,
          });
        }
        redirectToPage.registration.showIdFirst({
          rawSearch: filterQuery(filterKeys(['aim'])),
        });
      }
    } else if (mode.startsWith('registrationByDefault')) {
      saveEventName(EVENT_NAME);
      redirectToPage.registration.normal({ rawSearch: globalThis.location.search });
    } else if (mode === 'showQR') {
      self.showQRcode();
      onCloseModal(() => updatePageQueryString(filterQuery(filterKeys(['showQR']))));
    } else if (mode === 'addUGC') {
      handlePhotoUpload();
      onCloseModal(() => updatePageQueryString(filterQuery(filterKeys(['uploadUGC', 'tg']))));
    } else if (mode === 'turnMeIntoTag') {
      handlePhotoUpload({
        prefixFileName: getQueryVariable('tg'),
        ugcUploadMessage: t('home-turn-me-into-tag-upload-message'),
        asyncUgcUploadText: t('home-turn-me-into-tag-processing-message'),
      });
      onCloseModal(() => updatePageQueryString(filterQuery(filterKeys(['tg']))));
    } else if (mode === 'aiKiosk') {
      const aiKioskImageSrc = getQueryVariable('aiKioskImgSrc');
      if (aiKioskImageSrc) {
        handlePhotoAIPhotoAttach(aiKioskImageSrc);
      }
      onCloseModal(() => updatePageQueryString(filterQuery(filterKeys(['aiKioskImgSrc', 'aiKiosk']))));
    } else if (mode === 'addPhoto') {
      showScannedImage(
        {
          scannedImgSrc: getQueryVariable('imgSrc'),
          photoUId: getQueryVariable('photoId'),
        },
        {
          isHideAfterFinish: false,
          onSubmit: async (photoUId) => {
            showLoading();
            await pAttendeeAttachPhotosByQR(ATT_ID, [photoUId]);
          },
          onFinish: () => {
            updatePageQueryString(filterQuery(filterKeys(['imgSrc', 'photoId'])));
          },
        }
      );
    } else if (mode === 'unlock') {
      if (isValidToken(getQueryVariable('token'), opts.vipToken)) {
        showLoading();
        await unlockAccount();
      }
      updatePageQueryString(filterQuery(filterKeys(['token'])));
    } else if (mode === 'contactCompletion') {
      redirectToPage.contactCompletion({ rawSearch: globalThis.location.search });
    } else if (mode === 'openLinkByEmail' || mode === 'default') {
      await defaultCase({ isShowPrivacyLink, isShowFaqLink, isDisableLinkPhotos: opts.isDisableLinkPhotos });
    }

    if (parsedQueryParams.eventCode || parsedQueryParams.attendeeUid) {
      updatePageQueryString(filterQuery(filterKeys(['eName', 'uId'])));
    }

    fullScreenView.onShareBtn(self.newShareImage);
    fullScreenView.onDownloadBtn(self.newDownloadImage);
  };

  async function defaultCase({ isShowPrivacyLink, isShowFaqLink, isDisableLinkPhotos }) {
    saveEventName(EVENT_NAME);
    setLogo(EVENT_OPTS.webappCustomLogoSrc);
    multiAccountsView.render(multiAccounts.getList(), multiAccounts.getCurrentIndex());
    multiAccountsView.onSelectAccount(multiAccounts.setCurrentAccount);
    multiAccounts.onChangeCurrentIndex(multiAccountsView.activeAccount);
    multiAccounts.onChangeCurrentIndex(() => {
      globalThis.location.reload();
    });
    initShop();
    await getImageList(EVENT_DATA.id);

    initBottomMenu({ isShowPrivacyLink, isShowFaqLink });
    initQRReader({ isDisableLinkPhotos });
  }

  async function unlockAccount() {
    await addVisitDateInfo({
      eventName: EVENT_NAME,
      uId: ATT_ID,
      vDate: new Date(),
      prePaid: true,
    });
  }

  function initBottomMenu({ isShowPrivacyLink = false, isShowFaqLink = false } = {}) {
    if (VISIT_DATE === 1) {
      $('#selfie').on('click', () => {
        showFaceRegister(true);
      });
    } else {
      $('#selfie').hide();
    }

    if (isShowPrivacyLink) {
      $('#privacy-link').removeClass('menu__item_hidden');
    }

    if (isShowFaqLink) {
      $('#faq-link').removeClass('menu__item_hidden');
    }

    $('.emit-select-combo').on('click', async function () {
      const account = multiAccounts.getCurrentAccount();
      const webappPurchaseRedirectUrl = EVENT_OPTS.webappPurchaseRedirectUrl;
      if (webappPurchaseRedirectUrl) {
        redirectToExternalPurchasePage(webappPurchaseRedirectUrl, account);
        return;
      }
      localStorage.setItem('allPhotos', JSON.stringify(IMAGE_DATA));
      if (account) {
        saveAttendeeUid(account.attendeeUid);
        saveEventName(account.eventCode);
      }
      redirectToPage.combos();
    });

    $('.emit-select-photos').on('click', () => {
      modeSwitcher.switchToSelect();
      IMAGE_DATA.forEach((photo) => {
        if (photoDC.getCanBeDownloaded(photo)) {
          selectImage.select(photo.id);
        }
      });
    });

    $('#uploadPhotoBtn').on('click', () => {
      handlePhotoUpload();
    });
  }

  function initShop() {
    if (EVENT_OPTS.shopDigitalProductMsg) {
      localStorage.setItem('shopDigitalProductMsg', EVENT_OPTS.shopDigitalProductMsg);
    }
    if (EVENT_OPTS.shopDigitalProductDupMsg) {
      localStorage.setItem('shopDigitalProductDupMsg', EVENT_OPTS.shopDigitalProductDupMsg);
    }
    localStorage.setItem('shippingAddress', SHIPPING_ADDRESS);
    localStorage.setItem('enabledShopComboRequired', EVENT_OPTS.enabledShopComboRequired || false);
  }

  function logPhotoDelayValues() {
    console.log("Delay public's access to photos for:");
    console.log('- Non-VIP =', getValue(EVENT_OPTS.photoDelayMinutes));
    console.log('- VIP =', getValue(EVENT_OPTS.photoDelayVipMinutes));
    console.log('- TagsMin =', getValue(EVENT_OPTS.photoDelayTagsMinutes));
    console.log('- Tags =', getValue(EVENT_OPTS.photoDelayTags));

    function getValue(minutes) {
      return minutes ? `${minutes} minutes` : 'not set';
    }
  }

  function getImageList(eventId) {
    return findAttendeeByUIDAndEventId(ATT_ID, eventId)
      .then((response) => {
        HAS_FULL_IMAGE_ACCESS = response.result ? +response.result.has_full_image_access : 0;
        ATTENDEE_STATE = response?.result?.unlockState;
        localStorage.setItem('isVip', HAS_FULL_IMAGE_ACCESS);

        if (HAS_FULL_IMAGE_ACCESS) {
          $('.purchase-btn').hide();
        } else {
          $('.purchase-btn').show();
        }

        accessDataStorage.setData(
          makeAccessData({
            isFreeEvent: Boolean(EVENT_DATA.is_free),
            wasPaid: Boolean(HAS_FULL_IMAGE_ACCESS),
          })
        );

        const minInterval = HAS_FULL_IMAGE_ACCESS ? EVENT_OPTS.photoDelayVipMinutes : EVENT_OPTS.photoDelayMinutes;
        return { minInterval };
      })
      .then(({ minInterval }) =>
        findPhotos({
          eventId,
          attId: ATT_ID,
          minInterval,
          keyType: 'attendee_uid',
          keyValue: ATT_ID,
          maxSize: MAX_NUMBER_OF_PHOTOS,
          show_total_count: true,
          includeFavorites: EVENT_OPTS?.enableFavorites,
        })
      )
      .then((response) => {
        IMAGE_DATA = [...response.result.dataList].sort(comparisonPhotosByWatermark);

        if (VISIT_DATE === 1 && AUTO_RC !== true) {
          checkSelfiesList();
        }

        hideLoading();

        loadGallery();
      })
      .catch((err) => {
        console.error(err);
        if (err && err.resp.error.message_key === 'invalid_uid') {
          hideLoading();
        }
      });
  }

  // activation of user's photo uploading functionality
  function activateUserImageUpload() {
    if (EVENT_OPTS.enableAttendeePhotoUpl) {
      $('#uploadPhotoBtn').css('display', 'block');
      UGC.show();
    }
  }

  function checkSelfiesList() {
    self.getSelfieList(ATT_ID, (result) => {
      if (result.length === 0 && FACE_RECO && !isDisableSelfies && isEnableFaceRec) {
        $('.add-selfie').show();
        initAppSelfie();
      }
    });
  }

  function is360(photo) {
    return photo.image_type === '360_DEGREE';
  }

  function showFullScreen({ id }) {
    const clickedPhoto = IMAGE_DATA.find((photo) => photo.id === id);
    if (clickedPhoto && !photoDC.getCanBeMaximized(clickedPhoto)) return;
    const index = IMAGE_DATA.findIndex((photo) => photo.id === id);
    const access = accessDataStorage.getData();
    fullScreenView.showItems(
      IMAGE_DATA.map((photo) =>
        photoDC.fullScreenVM(photo, {
          watermarkSrc: getWatermarkSrc(photoAccess(photo, access), photo, watermarkStorage.getSrc()),
          canDownload: isAvailableToUsePhoto(photoAccess(photo, access), photo) && !isIPhone() && photoDC.getCanBeDownloaded(photo),
          canShare: isAvailableToUsePhoto(photoAccess(photo, access), photo),
        })
      ),
      index
    );
  }

  function stringContainsAny(str, substrings) {
    return substrings.some((substring) => str.includes(substring));
  }

  function isPhotoPaid(photo) {
    if (ATTENDEE_STATE?.status === 'UNLOCKED') return true;
    if (ATTENDEE_STATE?.tags?.length > 0) {
      if (stringContainsAny(photo.full_path, ATTENDEE_STATE.tags)) return true;
    }
    if (ATTENDEE_STATE?.photoIds?.length > 0) {
      if (ATTENDEE_STATE.photoIds.includes(photo.id)) return true;
    }
    return false;
  }

  function photoAccess(photo, access) {
    return {
      ...access,
      wasPaid: isPhotoPaid(photo),
    };
  }

  function canSelectPhotoById(id) {
    const photo = IMAGE_DATA.find((p) => p.id === id);
    if (!photo) return false;
    return !photoDC.isStockImage(photo) || photoDC.getCanBeDownloaded(photo);
  }

  function isStockImageById(id) {
    const photo = IMAGE_DATA.find((p) => p.id === id);
    return Boolean(photo) && photoDC.isStockImage(photo);
  }

  function loadGallery() {
    activateUserImageUpload();
    const access = accessDataStorage.getData();
    const photosViewModel = IMAGE_DATA.map((photo) =>
      photoDC.viewModel(photo, {
        watermarkSrc: getWatermarkSrc(photoAccess(photo, access), photo, watermarkStorage.getSrc()),
        canDownload: isAvailableToUsePhoto(photoAccess(photo, access), photo) && photoDC.getCanBeDownloaded(photo),
        canFavorite: Boolean(EVENT_OPTS?.enableFavorites) && photoDC.getCanShowFavorite(photo),
      })
    );

    galleryVC.render(photosViewModel);
    actionPanel.render(actionPanelButtons);

    if (HAS_FULL_IMAGE_ACCESS) {
      actionPanel.hideBtn('purchase');
    } else {
      actionPanel.showBtn('purchase');
    }
    $('.emit-select-photos').show();
    if (isMobile()) {
      actionPanel.showBtn('shareLink');
      actionPanel.disableBtn('delete');
      actionPanel.disableBtn('shareLink');
      modeSwitcher.switchToDefaultMode();
      galleryVC.enableIconType();

      galleryVC.onClick((data) => {
        if (modeSwitcher.isSelectMode()) {
          if (!canSelectPhotoById(data.id)) return;
          selectImage.toggle(data.id);
        } else if (modeSwitcher.isDefaultMode()) {
          if (data.clickUrl) {
            globalThis.open(data.clickUrl, '_blank', 'noopener,noreferrer');
            return;
          }
          showFullScreen(data);
        }
      });

      galleryVC.onLongTouch(({ id }) => {
        if (modeSwitcher.isDefaultMode() && canSelectPhotoById(id)) {
          selectImage.select(id);
        }
      });

      modeSwitcher.onSelectMode(galleryVC.enableSelect);
      modeSwitcher.onSelectMode(actionPanel.show);
      modeSwitcher.onSelectMode(selectedPanel.show);

      modeSwitcher.onDefaultMode(galleryVC.disableSelect);
      modeSwitcher.onDefaultMode(actionPanel.hide);
      modeSwitcher.onDefaultMode(selectedPanel.hide);

      selectImage.onUpdate((photos) => {
        if (photos.size === 0) {
          modeSwitcher.switchToDefaultMode();
        } else {
          modeSwitcher.switchToSelect();
        }
      });
    } else {
      // NOTE: Desktop
      galleryVC.enableSelect();
      galleryVC.onClick((data) => {
        if (data.clickUrl) {
          globalThis.open(data.clickUrl, '_blank', 'noopener,noreferrer');
          return;
        }
        if (!canSelectPhotoById(data.id)) return;
        selectImage.toggle(data.id);
      });
      galleryVC.enableView();
      galleryVC.onClickView(showFullScreen);

      selectImage.onUpdate((photos) => {
        if (photos.size === 0) {
          actionPanel.hide();
          selectedPanel.hide();
        } else {
          actionPanel.show();
          selectedPanel.show();
        }
      });
    }

    galleryVC.onClickDownloadBtn(self.downloadImage);
    galleryVC.onClickFavoriteBtn(toggleFavoritePhoto);

    selectImage.onSelect(galleryVC.select);
    selectImage.onUnselect(galleryVC.unselect);
    selectImage.onUnselectAll(galleryVC.unselectAll);

    selectImage.onUpdate((photos) => {
      if (photos.size === 0) {
        actionPanel.disableBtn('shareLink');
        actionPanel.disableBtn('multipleDownload');
      } else {
        const canSharePhoto = [...photos].every((id) => {
          const matchedPhoto = IMAGE_DATA.find((photo) => photo.id === id);
          return !matchedPhoto || isAvailableToUsePhoto(photoAccess(matchedPhoto, access), matchedPhoto);
        });
        if (canSharePhoto) {
          actionPanel.showBtn('shareLink');
          actionPanel.enableBtn('shareLink');
          actionPanel.showBtn('multipleDownload');
          actionPanel.enableBtn('multipleDownload');
        } else {
          actionPanel.disableBtn('shareLink');
          actionPanel.disableBtn('multipleDownload');
        }
      }
    });

    selectImage.onUpdate((photos) => {
      const canDelete = photos.size > 0 && ![...photos].some(isStockImageById);
      if (canDelete) {
        actionPanel.enableBtn('delete');
      } else {
        actionPanel.disableBtn('delete');
      }
    });

    selectImage.onUpdate((photos) => {
      selectedPanel.updateAmountOfSelect(photos.size);
    });

    if (IMAGE_DATA.filter(isAvailableToUsePhoto(accessDataStorage.getData())).length === 0) {
      actionPanel.disableBtn('shareLink');
    }

    actionPanel.onClickBtn('shareLink', () => {
      if (actionPanel.isDisabledBtn('shareLink')) {
        if (selectImage.array().length === 0) {
          alert(t('home-select-to-share-or-download-message'));
        } else {
          alert(t('home-share-download-locked-message'));
        }
      } else {
        const availablePhotos = IMAGE_DATA.filter(photoDC.includesById(selectImage.array()));
        if (availablePhotos.length === 0) {
          alert(t('home-select-without-watermark-message'));
        } else {
          shareSharingPage(availablePhotos[0].thumb_full_path, availablePhotos)
            .then(selectImage.unselectAll)
            .catch((error) => {
              alertMessagePopup(error.message);
            });
        }
      }
    });

    actionPanel.onClickBtn('purchase', () => {
      $('.emit-select-combo').trigger('click');
    });

    createAStoryBtn.onClick(() => {
      if (createAStory.allTagsHaveAPhoto(IMAGE_DATA, getRequiredTagsToGenerateStory())) {
        Promise.resolve()
          .then(showLoading)
          .then(() => createAStory.saveLastTime(Date.now()))
          .then(() => createAStoryBtn.hide())
          .then(() =>
            print(
              {
                eventId: EVENT_DATA.id,
                attendeeUid: ATT_ID,
                printerPoolName: EVENT_OPTS.storiesPrintPool,
                photosUid: createAStory
                  .extractPhotosByTags(IMAGE_DATA, getRequiredTagsToGenerateStory())
                  .map((photo) => photo.uid),
                isStory: true,
              },
              {
                keyType: 'event_public_api_key',
                keyValue: EVENT_DATA.public_api_key,
              }
            )
          )
          .then(() => alert(getTextForWaitingStory()))
          .then(hideLoading);
      }
    });

    actionPanel.onClickBtn('delete', () => {
      if (actionPanel.isDisabledBtn('delete')) {
        alert(t('home-select-to-delete-message'));
      } else {
        openDeleteImagesModal();
      }
    });

    actionPanel.onClickBtn('multipleDownload', async () => {
      if (actionPanel.isDisabledBtn('multipleDownload')) {
        if (selectImage.array().length === 0) {
          alert(t('home-select-to-share-or-download-message'));
        } else {
          alert(t('home-share-download-locked-message'));
        }
      } else {
        const availablePhotos = IMAGE_DATA.filter(photoDC.includesById(selectImage.array()));
        if (availablePhotos.length === 0) {
          alert(t('home-select-without-watermark-message'));
        } else {
          await multipleDownload(availablePhotos, ATT_ID);
          selectImage.unselectAll();
        }
      }
    });

    selectedPanel.onClickClearBtn(selectImage.unselectAll);
  }

  function comparisonPhotosByWatermark(photoA, photoB) {
    if (isEnabledWatermarkBySrc(photoA.full_path) && !isEnabledWatermarkBySrc(photoB.full_path)) return 1;
    if (!isEnabledWatermarkBySrc(photoA.full_path) && isEnabledWatermarkBySrc(photoB.full_path)) return -1;
    return 0;
  }

  const favoriteRequestManager = latestStateRequestManager({
    delayMs: 1000,
    sendRequest: ({ key, state }, done) => occoApi.photoFavoriteSet(ATT_ID, key, state, done),
    onError: (err) => alertMessagePopup(err.message_key || LANG.something_wrong),
  });


  function setPhotoFavoriteState(photoId, isFavorite) {
    IMAGE_DATA = IMAGE_DATA.map((photo) =>
      photo.id === photoId ? { ...photo, is_favorite: isFavorite } : photo
    );
    galleryVC.updateFavoriteState(photoId, isFavorite);
  }

  function toggleFavoritePhoto({ id }) {
    const photo = IMAGE_DATA.find((item) => item.id === id);
    if (!photo) return;
    const currentState = isPhotoFavorite(photo);
    const nextState = !currentState;
    setPhotoFavoriteState(id, nextState);
    favoriteRequestManager.schedule({
      key: id,
      serverState: currentState,
      desiredState: nextState,
      revertState: (confirmedState) => setPhotoFavoriteState(id, confirmedState),
    });
  }

  this.getSelfieList = function (attUid, callback, callbackError) {
    occoApi.profilePhotoListRetrieve(attUid, (err, result) => {
      if (err) {
        if (callbackError) {
          callbackError(err);
          return;
        }
        return alertMessagePopup(err.message_key);
      }
      if (callback) {
        callback(result);
      }
    });
  };

  this.newDownloadImage = function ({ id }) {
    waitingNotice.text(t('home-download-waiting-message'));
    waitingNotice.show();

    const photo = IMAGE_DATA.find(photoDC.isPhotoById(id));
    trackPhotoEvent({ activityName: 'Download', photoId: photo.id, attendeeUid: ATT_ID });
    const urlAsArray = photo.full_path.split('/');
    const fileName = urlAsArray[urlAsArray.length - 1];

    if (is360(photo)) {
      alert(t('home-download-360-message'));
    }

    downloadFile(photo.full_path, fileName).finally(waitingNotice.hide);
  };

  this.newShareImageUrl = function ({ id }) {
    const photo = IMAGE_DATA.find(photoDC.isPhotoById(id));
    shareFiles([photo]);
  };

  this.downloadImage = function ({ id }) {
    if (isIPhone()) {
      self.newShareImageUrl({ id });
    } else {
      self.newDownloadImage({ id });
    }
  };

  this.newShareImage = function ({ id }) {
    const photo = IMAGE_DATA.find(photoDC.isPhotoById(id));
    shareSharingPage(photo.thumb_full_path, [photo]);
  };
  function downloadFile(url, fileName) {
    return fetch(url)
      .then((res) => res.blob())
      .then((res) => {
        const aElement = document.createElement('a');
        aElement.setAttribute('download', fileName);
        const href = URL.createObjectURL(res);
        aElement.href = href;
        aElement.setAttribute('target', '_blank');
        aElement.click();
        URL.revokeObjectURL(href);
        aElement.remove();
      })
      .catch((e) => {
        console.error('downloadFile error:', e);
      });
  }

  function showFaceRegister(shouldRedirectToSelfiesPage, haveSelfies = true) {
    let content = `<div>
        <div>${haveSelfies ? t('home-face-register-help-message') : t('home-no-selfies-suggestion-message')}</div><br>
        <div>${t('home-no-face-mask-message')}</div><br>
            <div class="faceUploadContApp">
            <span class="label label-info"> </span>
                <br />
                <label id='labelUploadFaceImagesApp'
                    class='btn btn-primary btn-lg btn-circle btn-camera'
                    for='photoFaceUploadButtonApp'><i class="fa fa-camera"></i></label>
                <input type='file' name='file' class='file-upload' id='photoFaceUploadButtonApp' accept="image/*" capture>
                    <br><br>`;

    if (!haveSelfies) {
      content += `<br>
           <button type = "button" class = "btn btn-primary btn-lg" data-dismiss = "modal" > ${t('home-selfie-maybe-later-btn')} </button>`;
    }
    content += '</div>';
    customPopUp.html(content);
    customPopUp.show();
    initAppSelfie(shouldRedirectToSelfiesPage);
  }

  function openDeleteImagesModal() {
    const selectedStockImage = IMAGE_DATA.filter(photoDC.isStockImage).filter(
      photoDC.includesById(selectImage.array())
    );
    const warningMassageText = `${t('home-delete-stock-warning-message')}<br><br>`;
    const warningMassage = selectedStockImage.length > 0 ? warningMassageText : '';
    const content =
      `<div><h6>${warningMassage}${t('home-delete-confirm-message')}` +
      ` </h6><br> <br>
        <div class="form-inline">
            <div class="controls-row">
                <div class="input-group">
                    <label class="radio inline">
                        <input type="radio" class="rDelReason" name="deletePhotosRadio" value="AttendeeDeletePhotoNotWanted" checked="" style="vertical-align: middle;margin-right:5px;">${t('home-delete-reason-not-wanted')}
                    </label>
                </div>
                <div class="input-group">
                    <label class="radio inline">
                        <input type="radio" class="rDelReason" name="deletePhotosRadio" value="AttendeeDeletePhotoNotTheirs" style="vertical-align: middle;">
                        ${t('home-delete-reason-not-mine')}
                    </label>
                </div>
            </div>
        </div>
        <br>
        <button type="button" class="btn btn-light btn-lg" data-dismiss="modal">${t('cancel-btn')}</button>
        <button type="button" class="btn btn-danger btn-lg" onClick="occoAppPages.deleteSelectedImages()">${t('home-delete-confirm-btn')}</button></div>`;

    customPopUp.html(content);
    customPopUp.show();
  }

  // NOTE: Is used in the function openDeleteImagesModal
  this.deleteSelectedImages = function () {
    const selectedStockImagesId = IMAGE_DATA.filter(photoDC.isStockImage)
      .filter(photoDC.includesById(selectImage.array()))
      .map(photoDC.id);
    let selectedPhotosIdWithoutStockImage = [];
    if (selectedStockImagesId.length > 0) {
      selectedPhotosIdWithoutStockImage = selectImage.array().filter(photoDC.notIncludesById(selectedStockImagesId));
    } else {
      selectedPhotosIdWithoutStockImage = selectImage.array();
    }
    const result = selectedPhotosIdWithoutStockImage;
    if (result.length === 0) {
      customPopUp.hide();
      return;
    }
    showLoading();
    deleteImagesReq(result, $('input:radio.rDelReason:checked').val(), EVENT_DATA.id, 'attendee_uid', ATT_ID, (err) => {
      customPopUp.hide();
      if (err) {
        alert(err.message_key);
        return;
      }
      selectImage.unselectAll();
      getImageList(EVENT_DATA.id);
    });
  };

  function initAppSelfie() {
    const $photoFaceUploadButtonApp = $('#photoFaceUploadButtonApp');
    $photoFaceUploadButtonApp.on('change', handle);
    const $photoFaceUploadButtonApp2 = $('#photoFaceUploadButtonApp2');
    $photoFaceUploadButtonApp2.on('change', handle);
    faceReco.show();

    function handle() {
      showLoading();
      Promise.all(Array.from(this.files).map((file) => uploadSelfieImage(file)))
        .then(() => globalThis.location.reload())
        .catch((e) => {
          if (isUnsupportedPictureFormatError(e)) {
            alert(t('home-upload-unsupported-format-message'));
          } else {
            alert(t('home-upload-generic-error-message'));
          }
          hideLoading();
          console.error(e);
        });
    }
  }
  function handlePhotoAIPhotoAttach(aiKioskImageSrc) {
    const content2 = `<div class="uploadMassage__Text">
      <div>${t('home-upload-processing-message')}</div><br>
      <button id="aiKioskOk" type="button" class="btn btn-primary btn-lg" data-dismiss="modal">${t('ok-btn')}</button>
    </div>`;

    customPopUp.html(content2);
    customPopUp.show();
    onCloseModal(() => {
      updatePageQueryString(filterQuery(filterKeys(['aiKioskImgSrc', 'aiKiosk'])));
    });

    const $aiKioskOk = $('#aiKioskOk');
    $aiKioskOk.click(() => {
      occoApi.miniAlbumcreateCustomPhoto(EVENT_NAME, aiKioskImageSrc, ATT_ID, (err) => {
        if (err && err.message_key === 'attendee_upload_limit_reached') {
          alertMessagePopup(t('home-upload-limit-reached-message'));
        } else if (err) {
          return alert(err.message_key);
        }
      });
    });
  }

  function handlePhotoUpload({
    prefixFileName = '',
    asyncUgcUploadText = t('home-upload-processing-message'),
    ugcUploadMessage = t('home-upload-photo-message'),
  } = {}) {
    UGC.Off();
    const content = `<div class="uploadMassage__Text">
              <div>${ugcUploadMessage}</div><br>
              <label type="button" class="btn btn-primary btn-lg"  for='photoUploadButtonOk'>${t('ok-btn')}</label>
              <input type='file' name='file' class='file-upload'  id='photoUploadButtonOk' accept='image/*'  multiple />
          </div>`;
    customPopUp.html(content);
    customPopUp.show();
    if (IMAGE_DATA.length === 0) {
      $('#customUpload').css({
        position: 'relative',
        margin: '0 auto',
      });
    }
    const eventName = EVENT_DATA.name;
    const $photoUploadButtonOk = $('#photoUploadButtonOk');
    let activeFileSession;
    $photoUploadButtonOk.click(() => {
      activeFileSession = true;
    });
    const handler = (i, total, file) =>
      new Promise((resolve) => {
        $('#customUpload').css({
          position: 'absolute',
        });
        customImageUpload(file, {
          opts: EVENT_OPTS,
          eventId: Math.floor(Math.random() * 10001),
          eventName,
          attendeeUid: ATT_ID || null,
          generateFileName: true,
          prefixFileName,
          fileRootPath: 'usersCustomPhotos/',
          callbackAdd() {},
          callbackSuccess(imgPath) {
            occoApi.miniAlbumcreateCustomPhoto(eventName, imgPath, ATT_ID, (err) => {
              if (err && err.message_key === 'attendee_upload_limit_reached') {
                alert(t('home-upload-limit-reached-message'));
              } else if (err) {
                alert(err.message_key || t('home-upload-processing-error-message'));
                return;
              }
              const isUploadLastPhoto = total === i;
              if (!activeFileSession && isUploadLastPhoto) {
                getImageList(EVENT_DATA.id);
              }
              resolve();
            });
          },
        });
      });
    $photoUploadButtonOk.change(async function () {
      customPopUp.hide();
      activeFileSession = false;
      showLoading();
      if (this.value !== '') {
        const fileLength = this.files.length;
        for (let i = 0; i < fileLength; i += 1) {
          await handler(i, fileLength - 1, this.files[i]);
        }
      } else if (!activeFileSession) {
        getImageList(EVENT_DATA.id);
      }
      const content2 = `<div class="uploadMassage__Text">
      <div>${asyncUgcUploadText}</div><br>
      <button id="close" type="button" class="btn btn-primary btn-lg" data-dismiss="modal">${t('ok-btn')}</button>
      </div>`;
      customPopUp.html(content2);
      customPopUp.show();
      onCloseModal(() => {
        updatePageQueryString(filterQuery(filterKeys(['uploadUGC', 'tg'])));
      });
    });
  }
  this.showQRcode = function () {
    const attendeeId = ATT_ID;

    const content =
      `<div style="overflow-wrap: break-word;">
        <span class="" style="font-size:large;">${t('home-qr-modal-message')}</span><br><br>
        <div id="qrCodeContShow"></div><br><span >${attendeeId}</span>` +
      `<div>
        <button type="button" data-dismiss="modal" class="btn btn-primary" >
            ${t('close-btn')}
        </button>
        </div>`;
    customPopUp.html(content);
    customPopUp.show();
    const $qrCodeCont = $('#qrCodeContShow');
    $qrCodeCont.html('');
    $qrCodeCont.qrcode({
      text: attendeeId,
      label: attendeeId,
      size: 200,
      mode: 0,
      mSize: 0.045,
      mPosX: 0.5,
      mPosY: 0.5,
      fontcolor: '#000',
      fontname: 'Arial',
      ecLevel: 'H',
      render: 'image',
    });

    $('#scanQR').qrCodeReader({
      callback(code) {
        console.log('code', code);
        if (code) {
          showScannedImage(parseCode(code), {
            onSubmit: (photoUId) => {
              attendeeAttachPhotosByQR(ATT_ID, [photoUId]);
            },
          });
        }
      },
    });
  };

  // code = "https://dev-images.occo.io/ntij/0706dff0-bef8-11eb-b096-8baa8b5fac4a/2021/4/4/CUSTOM_2021_05_27_02_30_04.jpg&&&098637d0-bef8-11eb-ac40-9f850beb"
  function parseCode(code) {
    let scannedImgSrc;
    let photoUId;

    if (hasSubscribing('&&&', code)) {
      [scannedImgSrc, photoUId] = code.split('&&&');
    } else if (hasSubscribing('http', code)) {
      const [, rawQueryString] = code.split('?');
      const query = new URLSearchParams(rawQueryString);
      scannedImgSrc = query.get('imgSrc');
      photoUId = query.get('photoId');
    }

    if (scannedImgSrc === undefined || photoUId === undefined) {
      console.error('Not defined scannedImgSrc or photoUID', {
        scannedImgSrc,
        photoUId,
      });
    }

    return {
      scannedImgSrc,
      photoUId,
    };

    function hasSubscribing(substring, string) {
      return string.indexOf(substring) > -1;
    }
  }

  function showScannedImage(
    { scannedImgSrc, photoUId },
    { isHideAfterFinish = true, onSubmit = async () => {}, onCancel = async () => {}, onFinish = async () => {} } = {}
  ) {
    if (scannedImgSrc && photoUId) {
      const content = `<div>
        <span class="">${t('home-scanned-image-confirm-message')}</span><br><br>
        <img class="scanned-img" src="${scannedImgSrc}" alt=""><br><br>
        <button type='button' id="cancelAttachPhoto"  class='btn btn-primary btn-lg' data-dismiss = "modal" >${t('no-btn')}</button>&nbsp;&nbsp;
        <button type='button'  id="attachPhoto" class='btn btn-primary btn-lg'  >${t('yes-btn')}</button>
        </div><br>`;
      customPopUp.html(content);
      customPopUp.show();
      const finish = async () => {
        if (isHideAfterFinish) {
          customPopUp.hide();
        }
        await onFinish(photoUId);
      };
      $('#attachPhoto').on('click', async () => {
        await onSubmit(photoUId);
        await finish();
      });
      $('#cancelAttachPhoto').on('click', async () => {
        await onCancel(photoUId);
        await finish();
      });
    } else {
      console.error('Not defined scannedImgSrc or photoUID', {
        scannedImgSrc,
        photoUId,
      });
    }
  }

  function initQRReader({ isDisableLinkPhotos = false } = {}) {
    if (!isSessionExpired(multiAccounts.getCurrentAccount().regDate, EVENT_OPTS)) {
      $('.body').removeClass('qr_disabled');

      const $btn = $(`#openQRreader`);
      if (isDisableLinkPhotos) {
        // Mode for showing own QR code
        updateQRMenuText(true);
        $btn.click(self.showQRcode);
      } else {
        // Mode for scanning QR code
        updateQRMenuText(false);
        $btn.removeClass('qr-btn');
        $btn.qrCodeReader({
          callback(code) {
            if (code) {
              const codeMRC1 = getParameterByName('mrc1', code);
              if (codeMRC1 !== null) {
                remoteCapture(ATT_ID, codeMRC1);
              } else {
                captureEvents({
                  EventSource: 'WebApp',
                  EventName: 'QRScan',
                  EventType: 'info',
                  EventCode: EVENT_NAME,
                  AttendeeUid: ATT_ID,
                });
                showScannedImage(parseCode(code), {
                  onSubmit: (photoUId) => {
                    attendeeAttachPhotosByQR(ATT_ID, [photoUId]);
                  },
                });
              }
            }
          },
        });
      }
    }
  }

  function shareFiles(photos) {
    shareFilesBySrcs(photos.map(photoDC.src));
    trackListOfPhotoEvent({ activityName: 'Download', listOfPhotoId: photos.map(photoDC.id), attendeeUid: ATT_ID });
  }

  function shareFilesExec(files) {
    if (navigator.canShare && navigator.canShare({ files })) {
      navigator
        .share({
          files,
          title: t('home-media-share-title'),
        })
        .then(() => console.log('Successful share.'))
        .catch((error) => console.log('Failed or canceled share.', error));
    } else {
      alert(t('home-share-files-unsupported-message'));
    }
  }

  async function shareFilesBySrcs(srcs) {
    waitingNotice.bottomOffset('84px');
    waitingNotice.text(t('home-share-files-waiting-message'));
    waitingNotice.show();

    return downloadFiles(srcs).then(shareFilesExec).finally(waitingNotice.hide);

    function getNameByUrl(url) {
      const array = url.split('/');
      return array[array.length - 1];
    }

    async function downloadFiles(listOfSrc) {
      return new Promise(async (resolve, reject) => {
        const files = [];
        for (const src of listOfSrc) {
          try {
            const res = await fetch(src);
            const file = new File([await res.blob()], getNameByUrl(src), {
              type: res.headers.get('Content-Type'),
            });
            files.push(file);
          } catch (error) {
            reject(error);
          }
        }
        resolve(files);
      });
    }
  }

  function onCloseModal(cb) {
    $('#customPopUp .close').click(cb);
    $('[data-dismiss="modal"]').click(cb);
  }

  function getTextForWaitingStory() {
    return t('home-create-story-waiting-message');
  }

  function getRequiredTagsToGenerateStory() {
    return EVENT_OPTS.requiredTagsToGenerateStory ? EVENT_OPTS.requiredTagsToGenerateStory.split(',') : [];
  }

  function shareSharingPage(previewImg, photos) {
    return shareBucketApi
      .uploadFile({
        folderPath: `${EVENT_DATA.name}/`,
        file: prepareSharePage({
          ogpData: {
            title: t('webapp-ogp-title'),
            description: t('webapp-ogp-description'),
            image: previewImg,
          },
          eventCode: EVENT_DATA.name,
          attendeeUid: ATT_ID,
          photoData: photos,
          localizationContext: {
            orgId: EVENT_DATA.organisation?.id,
            eventCode: EVENT_DATA.name,
            languageSettings: EVENT_DATA.opts?.languageSettings,
          },
        }),
      })
      .then((url) => {
        const transformedUrl = transformS3UrlToShareDomain(url);
        shareUrl({ text: t('webapp-share-title'), url: transformedUrl });
        return transformedUrl;
      })
      .then((url) => {
        const timestreamEvents = [
          {
            EventSource: 'Webapp',
            EventName: 'SHARE_LINK',
            EventType: 'report',
            EventId: EVENT_DATA.id,
            EventCode: EVENT_DATA.name,
            AttendeeUid: ATT_ID,
            Count: photos.length,
            EventHref: globalThis.location.href,
            EventUrl: url,
          },
        ];

        photos.forEach(({ id, image_process_id }) =>
          timestreamEvents.push({
            EventSource: 'Webapp',
            EventName: 'FacebookShare',
            EventType: 'report',
            EventId: EVENT_DATA.id,
            EventCode: EVENT_DATA.name,
            AttendeeUid: ATT_ID,
            PhotoId: id,
            Count: 1,
            PipelineId: image_process_id,
            EventHref: globalThis.location.href,
          })
        );

        return captureEvents(timestreamEvents);
      })
      .catch((error) => {
        if (error.message_key) {
          alertMessagePopup(error.message_key);
        } else {
          alertMessagePopup(error.message);
        }
      });
  }
}


const occoAppPages = new OCCOAppPages();

occoAppPages.init();

globalThis.occoAppPages = occoAppPages;
